import React from "react";
import {GroupedPackageItem} from "types/entities/GroupedPackageItem";
import {getSelectedUpsell} from "utils/utility";
import {useTypedSelector} from "helpers/reducers";
import PackageUpsellItem from "pages/Front/Booking/components/PackageUpsell/PackageUpsellItem";

interface ItemLimitPackageUpsellItemProps {
    item: GroupedPackageItem;
}

/**
 * Displays a limited variant group using the regular PackageUpsellItem layout.
 * Only one package item in the group can be selected at a time.
 */
const ItemLimitPackageUpsellItem = (props: ItemLimitPackageUpsellItemProps) => {
    const bookingProcess = useTypedSelector(state => state.bookingState.bookingProcess);
    const selectedPackageId = props.item.items.find(packageItem => getSelectedUpsell(bookingProcess.upsell, packageItem))?.id;

    return (
        <div className="ItemLimitPackageUpsellItem flex flex-col items-center w-full space-y-4">
            {props.item.items.map(packageItem => (
                <PackageUpsellItem
                    key={packageItem.id}
                    packageItem={packageItem}
                    selectedPackage={null}
                    isNewLayout={true}
                    disabled={selectedPackageId !== undefined && selectedPackageId !== packageItem.id}
                />
            ))}
        </div>
    );
};

export default ItemLimitPackageUpsellItem;
